export default __webpack_public_path__ + "static/media/PN878U1.0ce9e682.jpg";